<section id="promo-code-section" class="section-card-content" data-cy="withdraw-promo-screen">
  <form [formGroup]="promoCodeForm">
    <p class="details tw-text-[15px] tw-text-[#020101] tw-mb-[28px]" data-cy="withdraw-promo-details">
      Consume a promotional code for wagering credit. Most promotional codes will be
      received via text, email, or by a physical handout card. Please refer to the source
      of the code for specific limitations and expiration. Promotional codes are
      redeemed for wagering credit only and cannot be withdrawn. Wagering credit is
      consumed prior to any cash balance for wagering and other purchases. Winnings
      from wagers made with wagering credit are cash and withdrawable.
    </p>

    <div class="amount-row tw-relative">
      <!-- Message section -->
      <!-- tw-top-[-18px] -->
      <span class="tw-absolute tw-bottom-[-19px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['promoCode'] && formVal['promoCode']?.errors
            && (formVal['promoCode'].touched || formVal['promoCode'].dirty)"
          data-cy="withdraw-promo-input-error"
        >
          {{
              'Required field promo code.'
          }}
        </span>
      </span>

      <span class="amount-deposit-usd tw-block tw-text-[16px] tw-text-[#5D5D5D]" data-cy="withdraw-promo-input-label">
        Promo Code:
      </span>
      <input
        formControlName="promoCode"
        id="promoCode"
        (keyup)="promoCodeValue()"
        type="text"
        class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
        placeholder=""
        amwager3DecimalInput
        data-cy="withdraw-promo-input"
      />
    </div>

    <button
      (click)="deposit()"
      [ngClass]="{'active': (promoCode && !isDepositing && formVal['promoCode'].valid)}"
      [disabled]="!promoCode || isDepositing || formVal['promoCode'].invalid"
      class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[30px] tw-mb-[10px]"
      data-cy="withdraw-promo-btn"
    >
      Deposit Now
    </button>

  </form>
</section>
